import type { ReactNode } from 'react';
import { X } from './icons';

export type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export function Chip({ tone = 'neutral', outline, children, onRemove, removeLabel, title }: { tone?: Tone; outline?: boolean; children: ReactNode; onRemove?: () => void; removeLabel?: string; title?: string }) {
  return (
    <span className={`chip ${tone !== 'neutral' ? `chip-${tone}` : ''} ${outline ? 'chip-outline' : ''}`} title={title}>
      {children}
      {onRemove && (
        <button type="button" aria-label={removeLabel ?? 'Remove'} onClick={onRemove}>
          <X aria-hidden="true" />
        </button>
      )}
    </span>
  );
}

/** A status word with a colour: the word carries the meaning, the colour supports it. */
export function Badge({ tone = 'neutral', children, title }: { tone?: Tone; children: ReactNode; title?: string }) {
  return (
    <span className={`chip ${tone !== 'neutral' ? `chip-${tone}` : ''}`} title={title}>
      {children}
    </span>
  );
}

export const draftTone = { new: 'success', modified: 'warning', deleted: 'danger' } as const;
export const draftWord = { new: 'New', modified: 'Modified', deleted: 'Deleted' } as const;
